import { useProperties } from '@core/offices/store/office';

export const useGetProperties = () => {
  return useProperties((state) => state.getProperties());
};

export const useGetPropertyPaginator = () => {
  return useProperties((state) => state.getPropertyPaginator());
};
